import Action from '../../Action'
// import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import InternalError from '../../generales/InternalError';
import ModalCreateHost from './ModalCreateHost';
import ModalCreateHostSNMP from './ModalCreateHostSNMP';
import ModalCIsDepend from './ModalCIsDepend';
import ModalCisDocs from '../ModalCisDocs';
const ModalMenuHost =({buscar_cis,cisSelected,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({
        // name:(editActive)?groupSelected.proxy_name:"",description:(editActive)?groupSelected.proxy_description:"",ip:(editActive)?groupSelected.proxy_ip:"",proxy_mode:(editActive)?groupSelected.proxy_mode:"Active"
          host: (editActive)?groupSelected.host:"",
          name: (editActive)?groupSelected.name:"",
          proxy_id: (editActive)?((groupSelected.proxy_hostid==""||groupSelected.proxy_hostid==null)?null:groupSelected.proxy_hostid):null,
          description: (editActive)?groupSelected.description:"",
          status: (editActive)?groupSelected.status_value:1,
          device_id: (editActive)?((groupSelected.technology_id==""||groupSelected.technology_id==null)?null:groupSelected.technology_id):null,
          alias: (editActive)?groupSelected.alias:"",
          location_lat: (editActive)?groupSelected.location_lat:"",
          location_lon: (editActive)?groupSelected.location_lon:"",
          serialno_a: (editActive)?groupSelected.serialno_a:"",
          macaddress_a: (editActive)?groupSelected.macaddress_a:"",
          brand_id: (editActive)?((groupSelected.brand_id==""||groupSelected.brand_id==null)?null:groupSelected.brand_id):null,
          model_id: (editActive)?((groupSelected.model_id==""||groupSelected.model_id==null)?null:groupSelected.model_id):null,
          agent_ip: (editActive)?(groupSelected.agent_ip==null?"":groupSelected.agent_ip):"",
          agent_port: (editActive)?((groupSelected.agent_port==null)?"10050":groupSelected.agent_port):"10050",
          snmp_ip: (editActive)?((groupSelected.snmp_ip==null)?"":groupSelected.snmp_ip):"",
          snmp_port:"161",// (editActive)?groupSelected.snmp_port:"",
          snmp_version: (editActive)?groupSelected.snmp_version:1,
          snmp_community: (editActive)?groupSelected.snmp_community:"public",
          groupids:(editActive)?((groupSelected.groupids==null)?[]:groupSelected.groupids.split(',').map(Number)):[],
          zona_groupid: (editActive)?(groupSelected.zona_groupid==""?null:groupSelected.zona_groupid):null
      })
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)

    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    // const dataCriticalities=useFetch('cassia/group_types','','','GET',server)
    // console.log(dataCriticalities)




    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

    useEffect(()=>{
     
          if( ManttoData.name=="" || ManttoData.description=="" || IpValid==false || ManttoData.ip==""){
              setDisabled(true)
          }else{
              setDisabled(false)
          }
    },[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=groupSelected.proxy_id
        }

        let  body ={}


        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/zabbix/proxies/'+url_add, {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(ManttoData),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
            
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              // setManttoData({type_id:0,name:""})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
          //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
               setIpValid(true)
               }else{
                   
                   setMsgError("La IP ya existe")
                   setIpValid(false)
               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['type_id']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
    }

    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            // buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])


    //   console.log(resultList)

    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const [listSelected,setListSelected]=useState(1)
    const [internalError,setInternalError]=useState(false)
    const hadleChangeList=(e)=>{
      setInternalError(false)
      setListSelected(e)
  }
    function renderAdminComponent() {
        try {
            switch (listSelected) {
                case 1:
                    return  <ModalCreateHost
                    devices={devices}
                    server={server}
                    editActive={editActive}
                    setEditActive={setEditActive}
                    setData={setData}
                    loading={loading}
                    setLoading={setLoading}
                    setError={setError}
                    dataUsers={dataUsers}
                    setRegisterIsValid={setRegisterIsValid}
                    closCreateCisModal={closCreateCisModal}
                    groupSelected={groupSelected}
                    languaje={languaje}
                    mode={mode}
                    setSearchTerm={setSearchTerm}
                    handleShowPopup={handleShowPopup}
                    buscar_cis={buscar_cis}
                    ManttoData={ManttoData}
                    setManttoData={setManttoData}
                    cisSelected={cisSelected}
                  ></ModalCreateHost>;
                  case 2:
                    return  <ModalCreateHostSNMP
                    devices={devices}
                    server={server}
                    editActive={editActive}
                    setEditActive={setEditActive}
                    setData={setData}
                    loading={loading}
                    setLoading={setLoading}
                    setError={setError}
                    dataUsers={dataUsers}
                    setRegisterIsValid={setRegisterIsValid}
                    closCreateCisModal={closCreateCisModal}
                    groupSelected={groupSelected}
                    languaje={languaje}
                    mode={mode}
                    setSearchTerm={setSearchTerm}
                    handleShowPopup={handleShowPopup}
                    buscar_cis={buscar_cis}
                    cisSelected={cisSelected}
                    ManttoData={ManttoData}
                    setManttoData={setManttoData}
                  ></ModalCreateHostSNMP>;
                  case 3:
                    return  <ModalCIsDepend
                    cisSelected={cisSelected}
                    devices={devices}
                    server={server}
                    editActive={editActive}
                    setEditActive={setEditActive}
                    setData={setData}
                    loading={loading}
                    setLoading={setLoading}
                    setError={setError}
                    dataUsers={dataUsers}
                    setRegisterIsValid={setRegisterIsValid}
                    closCreateCisModal={closCreateCisModal}
                    groupSelected={groupSelected}
                    languaje={languaje}
                    mode={mode}
                    setSearchTerm={setSearchTerm}
                    handleShowPopup={handleShowPopup}
                    buscar_cis={buscar_cis}
                    ManttoData={ManttoData}
                    setManttoData={setManttoData}
                  ></ModalCIsDepend>;
                   case 4:
                    return  <ModalCisDocs
                    devices={devices}
                    server={server}
                    editActive={editActive}
                    setEditActive={setEditActive}
                    setData={setData}
                    loading={loading}
                    setLoading={setLoading}
                    setError={setError}
                    dataUsers={dataUsers}
                    setRegisterIsValid={setRegisterIsValid}
                    closCreateCisModal={closCreateCisModal}
                    groupSelected={groupSelected}
                    languaje={languaje}
                    mode={mode}
                    setSearchTerm={setSearchTerm}
                    handleShowPopup={handleShowPopup}
                    buscar_cis={buscar_cis}
                    ManttoData={ManttoData}
                    setManttoData={setManttoData}
                    cisSelected ={cisSelected}
                  ></ModalCisDocs>;
                  default : <></>
               }
        } catch (error) {
            console.error('Error rendering component:', error);
            return <div>{lang[languaje['msgErrorPagina']]}</div>;
        }
    }
    const {name,description,ip}=ManttoData;
    return(
      
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {'Hoja de Vida del CI:     '+cisSelected.name}
                    </div>
                </div>
                <div className='content-card-modal-gs' >
               <div className='content-multicard-modal-gs'>
               <>
        {/* <div className='head-admin'> */}
                
                <div className='menu-multicard-modal-gs'>
                     <ol className='compact-menu-list' style={{justifyContent:'start'}}>
                        <li className={listSelected===1?'list-selected':''} onClick={() =>hadleChangeList(1)}>{'Información del CI'}</li>
                        <li className={listSelected===2?'list-selected':''} onClick={() =>hadleChangeList(2)}>{'Control de Cambios'}</li>
                        <li className={listSelected===3?'list-selected':''} onClick={() =>hadleChangeList(3)}>{'CIs Dependientes '}</li>
                       <li className={listSelected===4?'list-selected':''} onClick={() =>hadleChangeList(4)}>{'Documentación '}</li>
                    </ol>
                </div>
                <hr className='head-line-gs'></hr>
            {/* </div> */}
            <div className='cont-body-multicard-modal-gs 'style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
            {(internalError)?
            <InternalError/>
            :
            renderAdminComponent()
            
            //********************************************************** */
            }
            
                
            </div>
      </>
               </div>
                                    
                </div>
                </div>
        </div>
    )
}

export default ModalMenuHost